module.exports = __webpack_public_path__ + "img/pic_2_tc_new.daa42f67.png";